import React from 'react';
import iconify from '../iconify';

const Digital = ({customColor, ...props}) => (
  <svg width="1em" height="1em" viewBox="0 0 121.6 121.6" {...props}>
    <defs>
      <linearGradient
        id="digital-icon-linear-gradient"
        x1={1}
        y1={1}
        x2={0}
        y2={1}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#d3793b" />
        <stop offset={1} stopColor="#ea4154" />
      </linearGradient>
    </defs>
    <path
      fill={customColor ? 'currentColor' : 'url(#digital-icon-linear-gradient)'}
      d="M70.35 48.85h-19.1a2.39 2.39 0 0 0-2.4 2.4v19.1a2.39 2.39 0 0 0 2.4 2.4h19.1a2.39 2.39 0 0 0 2.4-2.4v-19.1a2.39 2.39 0 0 0-2.4-2.4zM68 68H53.65V53.65H68z"
    />
    <path
      fill={customColor ? 'currentColor' : 'url(#digital-icon-linear-gradient)'}
      d="M114.49 38.27a7.11 7.11 0 0 0-6.68 4.7H87.08v-6a2.41 2.41 0 0 0-2.4-2.4h-6.05V24.42h5.83a7.11 7.11 0 1 0 0-4.8h-8.23a2.39 2.39 0 0 0-2.4 2.4v12.5H63.2V22a2.4 2.4 0 0 0-4.8 0v12.5H47.77V13.79a7.11 7.11 0 1 0-4.79 0V34.5h-6.06a2.41 2.41 0 0 0-2.4 2.4v6H22a2.4 2.4 0 1 0 0 4.8h12.5v10.7H13.79a7.11 7.11 0 1 0 0 4.8h20.73v10.63H22a2.39 2.39 0 0 0-2.4 2.4v8.22a7.1 7.1 0 1 0 4.8 0v-5.82h10.1v6.05a2.41 2.41 0 0 0 2.4 2.4H43v12.51a2.4 2.4 0 1 0 4.79 0V87.08H58.4v20.73a7.11 7.11 0 1 0 4.8 0V87.08h10.63v12.51a2.4 2.4 0 1 0 4.8 0V87.08h6.05a2.41 2.41 0 0 0 2.4-2.4v-6.05h10.11v6.21a7.1 7.1 0 1 0 4.8 0v-8.22-.2-.19a2.4 2.4 0 0 0-2.4-2.4H87.08V63.2h12.51a2.4 2.4 0 0 0 0-4.8H87.08V47.77h20.73a7.1 7.1 0 1 0 6.68-9.5zM91.14 19.71A2.31 2.31 0 1 1 88.83 22a2.31 2.31 0 0 1 2.31-2.29zM45.38 4.8a2.31 2.31 0 1 1-2.31 2.31 2.31 2.31 0 0 1 2.31-2.31zM7.11 63.11a2.31 2.31 0 1 1 2.31-2.31 2.32 2.32 0 0 1-2.31 2.31zM22 93.44a2.31 2.31 0 1 1 2.3-2.3 2.3 2.3 0 0 1-2.3 2.3zm38.8 23.36a2.31 2.31 0 1 1 2.31-2.31 2.31 2.31 0 0 1-2.31 2.31zm38.79-23a2.31 2.31 0 1 1 2.31-2.31 2.31 2.31 0 0 1-2.31 2.35zM82.28 82.28h-43v-43h43zm32.21-34.6a2.31 2.31 0 1 1 2.31-2.31 2.3 2.3 0 0 1-2.31 2.31z"
    />
  </svg>
);

export default iconify(Digital);
